import axios from "../axiosPlugin.js";

const _ACCOUNTING_MANA_API = "/api/accountingManagement";
const _TRADEGROUP_API = "/api/tradeGroup"

// ***** this functions is used by William to test tradeGroup API; obsulate on 20210923
// export const tempTradeGroup = data => {
//   const {
//     brandId,
//     name,
//     status,
//   } = data
//   let queryString = `brandId=${brandId}`

//   if(name) {
//     queryString += `&name=${name}`
//   }

//   if(status) {
//     queryString += `&status=${status}`
//   }

//   return axios({
//     url: `${_TRADEGROUP_API}/list?${queryString}`,
//     method: 'get',
//     data: {}
//   })
// }

export const getAccountListService = data => {
  // const {
  //   brandId,
  //   name,
  //   moneyType,
  //   page,
  //   pageSize,
  //   forPos,
  // } = data;
  // let queryString = `brandId=${brandId}&page=${page}&pageSize=${pageSize}`;

  // if (typeof(forPos) == "boolean") {
  //   queryString += `&forPos=${forPos}`;
  // }
  // if (name) {
  //   queryString += `&name=${name}`;
  // }

  // if (moneyType) {
  //   moneyType.forEach(type => {
  //     queryString = queryString + "&moneyType=" + type;
  //   });
  // }

  return axios({
    url: `${_ACCOUNTING_MANA_API}/list`,
    method: "get",
    data: { data },
  });
};

export const addAccountService = data => {
  return axios({
    url: `${_ACCOUNTING_MANA_API}/create`,
    method: "post",
    data: { data },
  });
};

export const updateAccountService = data => {
  return axios({
    url: `${_ACCOUNTING_MANA_API}/update`,
    method: "post",
    data: { data },
  });
};
export const AccountDetailService = data => {
  return axios({
    url: `${_ACCOUNTING_MANA_API}/detail/${data.id}`,
    method: "get",
    data: { },
  });
};
export const deleteAccountService = data => {
  return axios({
    url: `${_ACCOUNTING_MANA_API}/delete/${data.id}`,
    method: "get",
    data: { data },
  });
};

export const approveAccountService = data => {
  return axios({
    url: `${_ACCOUNTING_MANA_API}/approve?brandId=${data.brandId}`,
    method: "post",
    data: { data },
  });
};